import { render } from "./ResetYourPassword.vue?vue&type=template&id=e3656b04&ts=true"
import script from "./ResetYourPassword.vue?vue&type=script&lang=ts"
export * from "./ResetYourPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__